<!-- HM checkout button - button to handle Stripe checkout -->
<template>
  <div id="app">
    <vue-stripe-checkout
      ref="checkoutRef"
      description="HIPAAMATE Software"
      image="/img/logo.png"
      :name="settings.title + ' Plan'"
      :amount="settings.price * 100"
      :currency="settings.currency"
      :billing-address="true"
      :zip-code="true"
      :allow-remember-me="false"
      :publishable-key="config.StripeKey"
      @done="done"
      @canceled="canceled"
    ></vue-stripe-checkout>
    <b-button type="button" variant="primary" @click="checkout">Buy Now</b-button>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'HMCheckoutButton',
  props: {
    settings: Object
  },
  computed: {
    ...mapState(['config'])
  },
  methods: {
    checkout() {
      this.$refs.checkoutRef.setCheckout();
      this.$refs.checkoutRef.open();
    },
    done({ token, args }) {
      // token - is the token object
      // args - is an object containing the billing and shipping address if enabled
      this.$emit('done', { id: this.settings.id, pkg: this.settings, token, args});
    },
    canceled() {
      this.$emit('canceled');
    }
  }
};
</script>
